import React from "react";

function CalenderDaysHeader() {
  return (
    <div className="p-2 flex justify-around    text-white">
      <div className="">SUN</div>
      <div className="">MON</div>
      <div className="">TUE</div>
      <div className="">WED</div>
      <div className="">THU</div>
      <div className="">FRI</div>
      <div className="">SAT</div>
    </div>
  );
}

export default CalenderDaysHeader;
